import { ThemeEvents } from '@theme/events';
import { formatMoney } from '@theme/utilities';

class CardProductPrice extends HTMLElement {
  #closestSection = null;

  connectedCallback() {
    this.#closestSection = this.closest('.shopify-section');
    this.#closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#closestSection = null;
  }

  get #productId() {
    return this.getAttribute('data-product-id');
  }

  get #priceElement() {
    return this.querySelector('[data-ref="price"]');
  }

  get #compareAtPriceElement() {
    return this.querySelector('[data-ref="compareAtPrice"]');
  }

  #onVariantUpdate = (event) => {
    const target = event.target;
    if (target instanceof HTMLElement && target.getAttribute('data-product-id') !== this.#productId) {
      return;
    }

    const variant = event.detail?.variant;
    if (!variant) return;

    this.#updatePrice(variant.price, variant.compare_at_price);
  };

  #updatePrice(price, compareAtPrice) {
    const hasSale = compareAtPrice && compareAtPrice > price;

    if (this.#priceElement) {
      this.#priceElement.textContent = formatMoney(price, Theme.settings.currency_format);
    }

    if (this.#compareAtPriceElement) {
      this.#compareAtPriceElement.textContent = hasSale ? formatMoney(compareAtPrice, Theme.settings.currency_format) : '';
      this.#compareAtPriceElement.hidden = !hasSale;
    }
  }
}

if (!customElements.get('card-product-price')) {
  customElements.define('card-product-price', CardProductPrice);
}
